import React, { useState, useRef, useEffect } from 'react'

const ChatComposer = ({ onSendMessage, disabled }) => {
  const [message, setMessage] = useState('')
  const [attachments, setAttachments] = useState([])
  const textareaRef = useRef(null)
  const fileInputRef = useRef(null)

  useEffect(() => {
    // Auto-resize textarea
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`
    }
  }, [message])

  const handleSubmit = e => {
    e.preventDefault()
    if ((message.trim() || attachments.length > 0) && !disabled) {
      onSendMessage(message, attachments)
      setMessage('')
      setAttachments([])
    }
  }

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSubmit(e)
    }
  }

  const handleFileSelect = e => {
    const files = Array.from(e.target.files)
    const validFiles = files.filter(file => {
      // Support PDFs, images, and MS Word documents
      const validTypes = [
        'application/pdf',
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      ]
      return validTypes.includes(file.type)
    })

    setAttachments(prevAttachments => [...prevAttachments, ...validFiles])
    // Reset file input
    e.target.value = null
  }

  const removeAttachment = index => {
    setAttachments(prevAttachments => prevAttachments.filter((_, i) => i !== index))
  }

  return (
    <form className='chat-composer' onSubmit={handleSubmit}>
      {attachments.length > 0 && (
        <div className='chat-composer-attachments'>
          {attachments.map((file, index) => (
            <div key={index} className='chat-attachment-preview'>
              <span className='chat-attachment-name'>{file.name}</span>
              <button
                type='button'
                className='chat-attachment-remove'
                onClick={() => removeAttachment(index)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      <div className='chat-composer-input-section'>
        <div className='chat-composer-input-wrapper'>
          <textarea
            ref={textareaRef}
            className='chat-composer-input'
            value={message}
            onChange={e => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder='Type a message...'
            disabled={disabled}
            rows={1}
            maxLength={1000}
          />
        </div>

        <div className='chat-composer-divider'></div>

        <div className='chat-composer-actions'>
          <input
            ref={fileInputRef}
            type='file'
            style={{ display: 'none' }}
            onChange={handleFileSelect}
            accept='.pdf,.jpg,.jpeg,.png,.gif,.doc,.docx'
            multiple
          />

          <button
            type='button'
            className='chat-composer-attachment'
            onClick={() => fileInputRef.current.click()}
            disabled={disabled}
          >
            <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
              <path
                d='M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
            Images/PDFs
          </button>

          <button
            type='submit'
            className='chat-composer-send'
            disabled={disabled || (!message.trim() && attachments.length === 0)}
          >
            <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
              <path d='M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' fill='currentColor' />
            </svg>
          </button>
        </div>
      </div>
    </form>
  )
}

export default ChatComposer
